import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class NewRelicErrorHandler implements ErrorHandler {

  handleError(error: any): void {

    // You can also log the error to the console or a different logging service
    // eslint-disable-next-line no-console
    console.error('An error occurred:', error);

    if (window.newRelicBrowserAgent && typeof window.newRelicBrowserAgent.noticeError === 'function') {
      window.newRelicBrowserAgent.noticeError(error);
    }

    throw error;
  }
}